import { CSSProperties, FlattenSimpleInterpolation } from "styled-components";

export const flexAlignVerticalContent = (
  x: CSSProperties["alignItems"],
  y: CSSProperties["justifyContent"],
) => `
  display: flex;
  flex-direction: column;
  justify-content: ${y};
  align-items: ${x};
`;

export const flexAlignHorizontalContent = (
  x: CSSProperties["justifyContent"],
  y: CSSProperties["alignItems"],
) => `
  display: flex;
  flex-direction: row;
  justify-content: ${x};
  align-items: ${y};
`;

export const backgroundImage = (src: string) =>
  `background-image: url('${process.env.NEXT_PUBLIC_CVNA_APP_CDN_URL}${src}');`;

export const MOBILE = "mobile";
export const LARGE_MOBILE = "largeMobile";
export const DESKTOP = "desktop";

export const breakpoints = {
  [MOBILE]: "max-width: 540px",
  [LARGE_MOBILE]: "max-width: 840px",
  [DESKTOP]: "min-width: 840px",
};

export const customMediaQuery = (
  width: string,
  content: string | string[] | FlattenSimpleInterpolation,
) => `
  @media screen and (${width}) { ${
    Array.isArray(content) ? content.join("\n") : content
  } }
`;

export const mq = (
  width: string,
  content: string | string[] | FlattenSimpleInterpolation,
) => {
  if (width === MOBILE) return customMediaQuery(breakpoints[MOBILE], content);
  if (width === LARGE_MOBILE)
    return customMediaQuery(breakpoints[LARGE_MOBILE], content);
  if (width === DESKTOP) return customMediaQuery(breakpoints[DESKTOP], content);

  return customMediaQuery(width, content);
};
